<script setup lang="ts">
/**
 * SG Incorporation (Pre) — 문서 [[Signers]] 자리 (MY SignersField 재사용).
 * entityCd 는 넘기지 않음 — Pre 단계는 L_ENTITY 가 없어 officer API 가 AUTH002 로 튕김.
 * directors 시드 + 수동 추가로 서명자 지정.
 */
import { computed } from 'vue';
import SignersField from '@/features/startTask/preset_task/my/preset/components/resignation/signers/SignersField.vue';
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';
import { useSgPreSigners } from './cdd/sgPreSignersContext';

const props = withDefaults(
  defineProps<{ varKey: string; boardLabel?: string }>(),
  { boardLabel: '' },
);

const ctx = useSgPreSigners();
const signers = computed(() => ctx.signersOf(props.varKey));
function onUpdate(list: SignerEntry[]) {
  ctx.setSigners(props.varKey, list);
}
</script>

<template>
  <SignersField
    :model-value="signers"
    :board-label="boardLabel"
    :var-key="varKey"
    entity-cd=""
    @update:model-value="onUpdate"
  />
</template>
